// extracted by mini-css-extract-plugin
export default {"ChartDemand":"ChartDemand_ChartDemand__KHtP-","ChartDemand__ChartContainer":"ChartDemand_ChartDemand__ChartContainer__rpCxg"};